import 'prismjs/plugins/line-highlight/prism-line-highlight';
export {
  default as plugin
} from 'prismjs/plugins/line-highlight/prism-line-highlight.css';
